import { useId, type ReactNode } from 'react';
import styles from './Section.module.css';

export interface SectionProps {
  /** Small grey group label above the surface (like iOS settings). */
  title?: ReactNode;
  /** Compact action at the right of the label, e.g. a plain "Bearbeiten". */
  action?: ReactNode;
  /** Grey note below the surface. */
  footer?: ReactNode;
  /**
   * `list`: rows with the usual inset (for `List`/`KeyValue`); `content`: padded;
   * `flush`: no padding, e.g. for a `DataTable`.
   */
  variant?: 'list' | 'content' | 'flush';
  children: ReactNode;
}

/** A labelled group on the grey background (docs/ux-richtlinien.md §6.8). */
export function Section({ title, action, footer, variant = 'list', children }: SectionProps) {
  const id = useId();
  return (
    <section className={styles.section} {...(title ? { 'aria-labelledby': id } : {})}>
      {(title || action) && (
        <div className={styles.head}>
          {title && (
            <h2 id={id} className={styles.title}>
              {title}
            </h2>
          )}
          {action && <div className={styles.action}>{action}</div>}
        </div>
      )}
      <div className={`${styles.surface} ${styles[variant]}`}>{children}</div>
      {footer && <div className={styles.footer}>{footer}</div>}
    </section>
  );
}
